export default __webpack_public_path__ + "static/media/drhorton.d287c5b3.png";